import axios from 'axios';

import { deepKeysToCamelCase, deepKeysToCamelCaseWithoutExcluded } from '@core/lib/fp/deepKeysToCamelCase';
import { deepKeysToSnakeCase, deepKeysToSnakeCaseWithoutExcluded } from '@core/lib/fp/deepKeysToSnakeCase';

const defaultTransformResponses = Array.isArray(axios.defaults.transformResponse)
  ? axios.defaults.transformResponse
  : [axios.defaults.transformResponse];

export const transformSnakeToCamel = [...defaultTransformResponses, deepKeysToCamelCase];

export const transformSnakeToCamelWithoutExcluded = (excludedKeys: string[]) => [
  ...defaultTransformResponses,
  deepKeysToCamelCaseWithoutExcluded(excludedKeys),
];

const defaultTransformRequests = Array.isArray(axios.defaults.transformRequest)
  ? axios.defaults.transformRequest
  : [axios.defaults.transformRequest];

export const transformCamelToSnake = [deepKeysToSnakeCase, ...defaultTransformRequests];

export const transformCamelToSnakeWithoutExcluded = (excludedKeys: string[]) => [
  deepKeysToSnakeCaseWithoutExcluded(excludedKeys),
  ...defaultTransformRequests,
];
